import { Chip } from "./chip";


export class DynamicChip implements Chip
{
    constructor(
        private _label: () => string,
        private _action: ($event?: MouseEvent, context?: unknown) => void,
        private _isVisible: () => boolean
    ) { }

    get label(): string
    {
        return this._label();
    }

    get action(): ($event?: MouseEvent, context?: unknown) => void
    {
        return this._action;
    }

    get isVisible(): boolean
    {
        return this._isVisible();
    }
}
